import React, { useCallback } from 'react';
import { FaeKey, ContextMenuData } from '../../../types';
import { FAE_COLORS } from '../../../gameData';
import { IconType, IconPathOptions } from '../../../utils/iconPath';
import PlaceholderIcon from '../../ui/PlaceholderIcon';

interface FaeItemProps {
    fae: FaeKey;
    contextMenu: ContextMenuData | null;
    closeContextMenu?: () => void;
    onFaeSelect: (f: FaeKey) => void;
    handleContextMenu?: (e: React.MouseEvent, target: string, type: ContextMenuData['type'], options?: string[]) => void;
    getIconPath: (type: IconType, name: string, options?: IconPathOptions) => string;
}

const FaeItem = React.memo(({
  fae,
  contextMenu,
  closeContextMenu,
  onFaeSelect,
  handleContextMenu,
  getIconPath
}: FaeItemProps) => {
  const handleClick = useCallback(() => {
    if (contextMenu && closeContextMenu) {
      closeContextMenu();
    } else {
      onFaeSelect(fae);
    }
  }, [contextMenu, closeContextMenu, onFaeSelect, fae]);

  const handleContext = useCallback((e: React.MouseEvent) => {
    if (handleContextMenu) {
      if (contextMenu && closeContextMenu) closeContextMenu();
      handleContextMenu(e, fae, 'fae');
    }
  }, [contextMenu, closeContextMenu, handleContextMenu, fae]);

  return (
    <div
      className={`interactive-element fae-icon-grid-item ${contextMenu ? 'no-hover' : ''}`}
      style={{ pointerEvents: contextMenu ? 'none' : 'auto' }}
      onClick={handleClick}
      onContextMenu={handleContext}
    >
      <PlaceholderIcon
        label=""
        colorClass="border-2"
        style={{
            backgroundColor: `${FAE_COLORS[fae as FaeKey]?.hex || '#000'}33`,
            borderColor: FAE_COLORS[fae as FaeKey]?.hex || '#666'
        }}
        imageUrl={getIconPath('fae', fae)}
      />
    </div>
  );
});

export default FaeItem;
